import { SubtotalLineItemSchema } from '@eigtech/line-items';
import { JobCornSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { RegionCornSchema, VendorRatesCornSchema } from '../../base/index.js';
export const CalculateEmsTarpingBillApiSchema = {
    params: z.object({
        jobId: JobCornSchema,
        regionId: RegionCornSchema,
        vendorRatesId: VendorRatesCornSchema,
    }),
    response: z.object({
        bill: SubtotalLineItemSchema,
    }),
};
